/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUsersEarningSessionClaimResponse
 */
export interface CreateUsersEarningSessionClaimResponse {
    /**
     * True when this device now holds the earning slot. False only when the caller is not a gameplay-capable client, which cannot earn regardless.
     * @type {boolean}
     * @memberof CreateUsersEarningSessionClaimResponse
     */
    claimed: boolean;
}

/**
 * Check if a given object implements the CreateUsersEarningSessionClaimResponse interface.
 */
export function instanceOfCreateUsersEarningSessionClaimResponse(value: object): value is CreateUsersEarningSessionClaimResponse {
    if (!('claimed' in value) || value['claimed'] === undefined) return false;
    return true;
}

export function CreateUsersEarningSessionClaimResponseFromJSON(json: any): CreateUsersEarningSessionClaimResponse {
    return CreateUsersEarningSessionClaimResponseFromJSONTyped(json, false);
}

export function CreateUsersEarningSessionClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUsersEarningSessionClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimed': json['claimed'],
    };
}

export function CreateUsersEarningSessionClaimResponseToJSON(json: any): CreateUsersEarningSessionClaimResponse {
    return CreateUsersEarningSessionClaimResponseToJSONTyped(json, false);
}

export function CreateUsersEarningSessionClaimResponseToJSONTyped(value?: CreateUsersEarningSessionClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimed': value['claimed'],
    };
}

